import styled from 'styled-components'
import { useCallback, useState } from 'react'
import { signUpUser } from 'utils/aws/authService'
const StyledSignUpForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  > div {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    label {
      display: flex;
      width: auto;
      margin: 0 auto;
    }
    input {
      display: flex;
      width: 250px;
    }
  }
  > button {
    margin: 10px auto;
    width: 200px;
  }
`
export const SignUp = () => {
  const [email, setEmail] = useState()
  const [password, setPassword] = useState()

  const handleUsernameChange = useCallback((e) => {
    setEmail(e.target.value)
  }, [])

  const handlePasswordChange = useCallback((e) => {
    setPassword(e.target.value)
  }, [])

  const handleSignUpUser = useCallback(async () => {
    await signUpUser({ email, password })
  }, [email, password])

  return (
    <StyledSignUpForm>
      <div>
        <label htmlFor="email">Email</label>
        <input name="email" type="email" onChange={handleUsernameChange} />
      </div>
      <div>
        <label htmlFor="password">Password</label>
        <input
          name="password"
          type="password"
          onChange={handlePasswordChange}
        />
      </div>
      <button type="button" value="Sign up" onClick={handleSignUpUser}>
        Sign up
      </button>
    </StyledSignUpForm>
  )
}
